import { render, staticRenderFns } from "./acceptTable.vue?vue&type=template&id=51a3146a&scoped=true"
import script from "./acceptTable.vue?vue&type=script&lang=js"
export * from "./acceptTable.vue?vue&type=script&lang=js"
import style0 from "./acceptTable.vue?vue&type=style&index=0&id=51a3146a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a3146a",
  null
  
)

export default component.exports